// extracted by mini-css-extract-plugin
module.exports = {"BodyCopy":"BodyCopy__e3iew"};